import { css } from '@emotion/react';
import { Trans } from 'i18n';

import { theme } from '../theme';

const disclaimerText = css`
  font-size: ${theme.fontSize.sm};
  margin-bottom: ${theme.spacing.xl};
`;
const disclaimerTextUs = css`
  font-size: ${theme.fontSize.sm};
  margin-bottom: 0;
`;

const UsDisclaimer = () => (
  <p css={disclaimerTextUs}>
    <Trans i18nKey="rebooking.disclaimerUnitedStates">
      This fare is bilaterally agreed between Scandinavian Airlines System (SAS) and the selected airline(s).To ensure
      that you get this fare, the reservation should be made now.Taxes including the September 11th Security Fee are
      included except where local airport taxes are collected at check-in time.Unless you select a one-way trip on the
      prior page, fares are each way based on required roundtrip purchase.SAS Business passengers (class codes C, D, Z &
      I) on SAS transatlantic flight itineraries will be seated in the SAS Business cabin on the transatlantic flight&
      in premium Economy (SAS Plus) on SAS-operated connecting flights, if any, within Scandinavia and Europe.Business
      class may not be available on SAS codeshare flights operated by other carriers and on connecting flights operated
      by other carriers.SAS Plus (class codes Y, S, B & P) is available on SAS-operated flights. This service is not
      available on SAS codeshare flights operated by other carriers & on connecting flights operated by other carriers
    </Trans>
  </p>
);

export const DisclaimerText = ({ isUs }: { isUs?: boolean | null }) => {
  const additionalBaggageText = 'Additional baggage fees may apply';
  const link = 'https://www.flysas.com/us-en/legal-info/optional-services-fees/';
  return (
    <>
      {isUs && <UsDisclaimer />}
      <p css={disclaimerText}>
        <Trans
          i18nKey="rebooking.disclaimer"
          components={{ anchorLink: isUs ? <a href={link} /> : <>{additionalBaggageText}</> }}
          defaults={`• Displayed prices applies to one adult including taxes & carrier-imposed fees. • The above products, rules
          and services apply on SAS-operated flights. • Products and services offered by our partner airlines may
          differ. • Lounge and Fast track are included in SAS Plus and SAS Business at the airports where they are
          available. • SAS Plus is not available on SAS codeshare flights and connecting flights operated by other
          carriers. • Additional baggage fees may apply. • Out-and inbound fares are interdependent and subject to
          change. • The Ticket is only valid for the sequence of transportation shown on it. More info in Conditions of
          carriage section 4.5.`}
        />
      </p>
    </>
  );
};

export const DisclaimerTextSAR = ({ isUs }: { isUs?: boolean }) => (
  <>
    {isUs && <UsDisclaimer />}
    <p css={disclaimerText}>
      <Trans i18nKey="disclaimer.sar">
        Displayed price applies to one adult excluding taxes & carrier-imposed fees. The above products and services
        apply on SAS-operated flights to/from certain destinations.
      </Trans>
    </p>
  </>
);

export const DisclaimerTextSky = () => (
  <>
    <p css={disclaimerText}>
      <Trans i18nKey="disclaimer.sky">
        Displayed price applies to one adult. Please note that taxes & carrier-imposed fees are indicative only and may
        change (upwards or downwards) depending on the flight chosen. The final price will be stated on the Payment
        Page. If a partner airline cancels a flight, SAS EuroBonus cannot guarantee rebooking to another flight unless
        the operating airline rebooks your ticket. SAS EuroBonus can only rebook you to another partner airline award
        ticket if such a ticket is available for purchase. For flights with airlines other than SAS, the terms and
        conditions of carriage of the respective airline apply.
      </Trans>
    </p>
  </>
);
